import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import E from 'wangeditor';

@Component({
  selector: 'app-g-ueditor',
  templateUrl: './g-ueditor.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GUeditorComponent),
      multi: true
    }
  ]
})
export class GUeditorComponent implements AfterViewInit, OnDestroy, OnInit, ControlValueAccessor {
  @Input() value: string;

  @Output() valueChange = new EventEmitter<string>();
  @ViewChild('ueditor') ueditor: ElementRef;

  editor: E;

  constructor(injector: Injector, viewRef: ViewContainerRef, elementRef: ElementRef) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.editor) {
      this.editor.destroy();
    }
    this.editor = null;
  }

  ngAfterViewInit(): void {
    const div = document.createElement('div');
    div.id = `r_${this.guid2()}`;
    this.ueditor.nativeElement.append(div);
    const self = this;
    this.editor = new E(`#${div.id}`);
    this.editor.config.zIndex = 99;
    this.editor.config.focus = false;
    // 配置 onchange 回调函数
    this.editor.config.onchange = function (newHtml) {
      self.valueChange.emit(newHtml);
    };
    this.editor.create();
  }

  writeValue(obj: any): void {
    if (!obj) {
      this.editor.txt.html('');
    } else {
      this.editor.txt.html(obj);
    }
  }

  registerOnChange(fn: any): void {
    this.valueChange.emit = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  guid2() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
  }
}
